import templateStr from 'text!../templates/youtube.html';

export default ['$sce', function ($sce) {
    return {
        restrict: 'AE',
        scope: {
            videoId: '@'
        },
        replace: true,
        template: templateStr,
        link: function link(scope) {
            scope.$watch('videoId', function (videoId) {
                if (videoId) {
                    scope.url = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + videoId);
                }
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/youtube/directives/Youtube.js
// module id = 2066
// module chunks = 0